export enum RequestRegistrationCancellationStatus {
    Open = 0,
    Accepted = 1,
    Rejected = 2
}
